import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const DemoPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: "left",
}));

export default function AddProducts() {
  return (
    <div className="AddProducts">
      <Stack direction="column">
        <DemoPaper variant="outlined">
          {" "}
          <Stack direction="column" spacing={0}>
            {" "}
            <Stack
              direction="row"
              alignItems="flex-end"
              justifyContent="space-between"
            >
              <Container>
                <h2>Add Product</h2>
                <Breadcrumbs aria-label="breadcrumb">
                  <Link underline="hover" color="inherit" href="/">
                    MUI
                  </Link>
                  <Link
                    underline="hover"
                    color="inherit"
                    href="/material-ui/getting-started/installation/"
                  >
                    Core
                  </Link>
                  <Link
                    underline="hover"
                    color="text.primary"
                    href="/material-ui/react-breadcrumbs/"
                    aria-current="page"
                  >
                    Breadcrumbs
                  </Link>
                </Breadcrumbs>
              </Container>{" "}
              <Grid
                container
                justifyContent="flex-end"
                alignItems="center"
                spacing={1}
              >
                <Grid item xs="auto">
                  {" "}
                  <Button variant="outlined" color="error">
                    Discard Changes
                  </Button>
                </Grid>
                <Grid item xs="auto">
                  <Button variant="contained">Add Product</Button>{" "}
                </Grid>
              </Grid>
            </Stack>
          </Stack>
        </DemoPaper>
      </Stack>

      <Stack
        spacing={{ xs: 1, sm: 2 }}
        direction="row"
        useFlexGap
        flexWrap="wrap"
        justifyContent="space-between"
      >
        <DemoPaper
          variation="outlined"
          sx={{
            width: "50%",
          }}
        >
          <Stack direction="column" spacing={1}>
            <h3>General Information</h3>
            <TextField fullWidth label="Product Name" id="fullWidth" />
            <TextField
              fullWidth
              label="Product Description"
              id="fullWidth"
              multiline
              rows={4}
            />
          </Stack>
        </DemoPaper>
        <DemoPaper
          variation="outlined"
          sx={{
            width: "43%",
          }}
        >
          <Stack direction="column">
            <h3>Product Image</h3>
            <TextField fullWidth label="Product Name" id="fullWidth" />
            <Button
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              startIcon={<CloudUploadIcon />}
            >
              Note: Include an image list of uploaded file. It must also accept
              only jpg or png, in an indicated size Upload file
              <VisuallyHiddenInput type="file" />
            </Button>
          </Stack>
        </DemoPaper>
      </Stack>
    </div>
  );
}
